/**
 * Implement Vuex Store Namespaced Module for Inquiry Request
 * Add Namespace into modules to avoid Module Store Objects conflicts;
 * @see https://vuex.vuejs.org/guide/modules.html#namespacing
 *
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 * @since Version 0.1.6
 */
const requestStates = {
    toggleRequestDetails: false,
};
const getters = {
    toggleRequestDetails(state) {
        return state.toggleRequestDetails;
    },
};
const mutations = {
    showRequestDetails(state) {
        state.toggleRequestDetails = true;
    },
    hideRequestDetails(state) {
        state.toggleRequestDetails = false;
    },
};
export default {
    namespaced: true,
    state: requestStates,
    getters,
    mutations,
};
